import {
  Box,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
} from '@everlywell/ui-kit';
import YouTubeEmbed from 'components/YouTubeEmbed';
import React from 'react';

export type YouTubeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  videoUrl?: string;
};

export default function YouTubeModal({
  isOpen,
  onClose,
  videoUrl,
}: YouTubeModalProps) {
  if (!isOpen || !videoUrl) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {/* Desktop Close Button */}
      <Box
        position="fixed"
        top="8 !important"
        right="4"
        zIndex="popover"
        display={['none', null, 'block']}
      >
        <ModalCloseButton zIndex="overlay" />
      </Box>
      <ModalContent maxWidth={['90%', '65%']} position="relative">
        {/* Mobile Close Button */}
        <ModalCloseButton
          top={['-30px']}
          right={['-15px']}
          zIndex="10"
          display={['block', null, 'none']}
        />
        <ModalBody padding="0">
          <YouTubeEmbed videoUrl={videoUrl} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
